import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../types/types';
import { onOpen } from './events/onOpen';
import { NavigationPanelChat } from '../../components/NavigationPanelChat/NavigationPanelChat';
import { INavigationPanelChatEvents, INavigationPanelChatFields } from '../../components/NavigationPanelChat/types';
import { isKanbanchiUser } from '../../../../../../store/model/authUser/selectors/isKanbanchiUser';
import { getUnreadChatsCount } from 'app/view/react_components/main/chatView/store/chatView/selectors/getUnreadChatsCount';
import { isShowChat } from 'app/store/model/authUser/selectors/isShowChat';

const mapStateToProps = (
    state: IApplicationState,
): INavigationPanelChatFields => {
    return {
        isShow: isShowChat(state),
        unread: getUnreadChatsCount(state),
    };
};

const mapDispatchToProps = (
    dispatch: any
): INavigationPanelChatEvents => {
    return {
        onOpen: () => dispatch(onOpen())
    }
}

export const NavigationPanelChatHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(NavigationPanelChat);
NavigationPanelChatHOC.displayName = 'NavigationPanelChatHOC';
